export default function NewsCardSkeleton({ isMobile = false }) {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border overflow-hidden animate-pulse ${
        isMobile ? "flex-shrink-0 min-w-[220px] h-64" : "min-w-[280px] h-64"
      }`}
    >
      {/* Image skeleton */}
      <div className="w-full h-32 bg-gray-200"></div>

      {/* Content skeleton */}
      <div className="p-3">
        <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-1/2 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-2/3"></div>
      </div>
    </div>
  );
}
